/* Vael 2.0 — Editorial
   Scroll reveal + hero node network. No dependencies.
   Respects prefers-reduced-motion, pauses the canvas when off-screen or when the tab is hidden. */
(function () {
  'use strict';

  var doc = document;
  window.__vaelReady = true;
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------- Scroll reveal ---------- */
  var revealObserver = null;

  function reveal(root) {
    var scope = root || doc;
    var items = scope.querySelectorAll('[data-reveal]:not(.is-in)');
    var i;
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      for (i = 0; i < items.length; i++) items[i].classList.add('is-in');
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    }
    for (i = 0; i < items.length; i++) revealObserver.observe(items[i]);
  }

  /* ---------- Hero node network ---------- */
  function toRgb(hex, fallback) {
    var h = (hex || fallback || '#F1EFE8').replace('#', '');
    if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
    var num = parseInt(h, 16);
    if (isNaN(num)) num = 0xF1EFE8;
    return ((num >> 16) & 255) + ',' + ((num >> 8) & 255) + ',' + (num & 255);
  }

  function Network(canvas) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.line = toRgb(canvas.getAttribute('data-line'), '#F1EFE8');
    this.accent = toRgb(canvas.getAttribute('data-accent'), '#A08A63');
    this.nodes = [];
    this.running = false;
    this.visible = true;
    this.raf = null;
    this.w = 0;
    this.h = 0;
    this.linkDist = 160;
    this.dpr = Math.min(window.devicePixelRatio || 1, 2);
    this.tick = this.tick.bind(this);
  }

  Network.prototype.resize = function () {
    var rect = this.canvas.getBoundingClientRect();
    this.w = Math.max(rect.width, 1);
    this.h = Math.max(rect.height, 1);
    this.canvas.width = Math.round(this.w * this.dpr);
    this.canvas.height = Math.round(this.h * this.dpr);
    this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    this.linkDist = Math.min(190, Math.max(120, this.w * 0.16));
    var count = Math.round((this.w * this.h) / 24000);
    this.seed(Math.max(16, Math.min(46, count)));
  };

  Network.prototype.seed = function (count) {
    this.nodes = [];
    for (var i = 0; i < count; i++) {
      var accent = Math.random() < 0.12;
      this.nodes.push({
        x: Math.random() * this.w,
        y: Math.random() * this.h,
        vx: (Math.random() - 0.5) * 0.28,
        vy: (Math.random() - 0.5) * 0.28,
        r: accent ? 2.2 : 1.4,
        accent: accent
      });
    }
  };

  Network.prototype.draw = function () {
    var ctx = this.ctx;
    var n = this.nodes;
    var d = this.linkDist;
    var d2 = d * d;
    var i, j, k, dx, dy, dist2, alpha, p;
    ctx.clearRect(0, 0, this.w, this.h);
    ctx.lineWidth = 1;
    for (i = 0; i < n.length; i++) {
      for (j = i + 1; j < n.length; j++) {
        dx = n[i].x - n[j].x;
        dy = n[i].y - n[j].y;
        dist2 = dx * dx + dy * dy;
        if (dist2 < d2) {
          alpha = (1 - Math.sqrt(dist2) / d) * 0.22;
          ctx.strokeStyle = 'rgba(' + this.line + ',' + alpha.toFixed(3) + ')';
          ctx.beginPath();
          ctx.moveTo(n[i].x, n[i].y);
          ctx.lineTo(n[j].x, n[j].y);
          ctx.stroke();
        }
      }
    }
    for (k = 0; k < n.length; k++) {
      p = n[k];
      ctx.fillStyle = p.accent ? 'rgba(' + this.accent + ',0.9)' : 'rgba(' + this.line + ',0.45)';
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fill();
    }
  };

  Network.prototype.step = function () {
    var m = 40;
    for (var i = 0; i < this.nodes.length; i++) {
      var p = this.nodes[i];
      p.x += p.vx;
      p.y += p.vy;
      if (p.x < -m) p.x = this.w + m;
      if (p.x > this.w + m) p.x = -m;
      if (p.y < -m) p.y = this.h + m;
      if (p.y > this.h + m) p.y = -m;
    }
  };

  Network.prototype.tick = function () {
    if (!this.running) return;
    this.step();
    this.draw();
    this.raf = window.requestAnimationFrame(this.tick);
  };

  Network.prototype.start = function () {
    if (this.running || reduceMotion) return;
    this.running = true;
    this.raf = window.requestAnimationFrame(this.tick);
  };

  Network.prototype.stop = function () {
    this.running = false;
    if (this.raf) window.cancelAnimationFrame(this.raf);
    this.raf = null;
  };

  function initNetwork(canvas) {
    if (canvas.__vNet || !canvas.getContext) return;
    var net = new Network(canvas);
    if (!net.ctx) return;
    canvas.__vNet = net;
    net.resize();
    net.draw();
    if (reduceMotion) return;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          net.visible = entry.isIntersecting;
          if (entry.isIntersecting && !doc.hidden) net.start();
          else net.stop();
        });
      }).observe(canvas);
    } else {
      net.start();
    }

    doc.addEventListener('visibilitychange', function () {
      if (doc.hidden) net.stop();
      else if (net.visible) net.start();
    });

    var timer;
    var lastWidth = net.w;
    function onResize(width) {
      if (Math.abs(width - lastWidth) < 2) return;
      lastWidth = width;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var wasRunning = net.running;
        net.stop();
        net.resize();
        net.draw();
        if (wasRunning || net.visible) net.start();
      }, 200);
    }
    if ('ResizeObserver' in window) {
      new ResizeObserver(function (entries) {
        onResize(entries[0].contentRect.width);
      }).observe(canvas);
    } else {
      window.addEventListener('resize', function () {
        onResize(canvas.getBoundingClientRect().width);
      });
    }
  }

  function init(root) {
    var scope = root || doc;
    reveal(scope);
    var nets = scope.querySelectorAll('canvas[data-v-network]');
    for (var i = 0; i < nets.length; i++) initNetwork(nets[i]);
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  doc.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();